import { render, staticRenderFns } from "./StickyItem.vue?vue&type=template&id=519b7560&scoped=true"
import script from "./StickyItem.vue?vue&type=script&lang=js"
export * from "./StickyItem.vue?vue&type=script&lang=js"
import style0 from "./StickyItem.vue?vue&type=style&index=0&id=519b7560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b7560",
  null
  
)

export default component.exports